var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-root"},[_c('div',{class:{'loading-root-content':_vm.isGlobal,'loading-locality-content':!_vm.isGlobal}},[_c('PtIcon',{style:(`fontSize: ${_vm.size}px`),attrs:{"icon":"SolidLoadingBars"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }